import Vuex from 'vuex';
import userService from 'Assets/js/components/userService';

const tryGetUserInstance = () => {
  if (!window.userInstance) {
    window.userInstance = new Vuex.Store({
      state: {
        instance: userService.getInstance()
      },
      getters: {
        userInstance: (state) => state.instance
      }
    });
  }
  return window.userInstance;
};

const userInstance = tryGetUserInstance();

export default userInstance;
